var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueUrgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.87891,
    y: 5.87695,
    width: 7.83673,
    height: 7.83673,
    rx: 1.95918,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.87891,
    y: 5.87695,
    width: 7.83673,
    height: 7.83673,
    rx: 1.95918,
    fill: "#979797",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.921 2.93945C3.37998 2.93945 2.94141 3.37803 2.94141 3.91905V9.7966C2.94141 10.3376 3.37998 10.7762 3.921 10.7762C4.46236 10.7762 4.90123 10.3373 4.90123 9.79596V5.87831C4.90123 5.3373 5.33981 4.89872 5.88082 4.89872H9.79847C10.3395 4.89872 10.7781 4.4601 10.7781 3.91905C10.7781 3.37803 10.3396 2.93945 9.79855 2.93945H3.921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.921 2.93945C3.37998 2.93945 2.94141 3.37803 2.94141 3.91905V9.7966C2.94141 10.3376 3.37998 10.7762 3.921 10.7762C4.46236 10.7762 4.90123 10.3373 4.90123 9.79596V5.87831C4.90123 5.3373 5.33981 4.89872 5.88082 4.89872H9.79847C10.3395 4.89872 10.7781 4.4601 10.7781 3.91905C10.7781 3.37803 10.3396 2.93945 9.79855 2.93945H3.921Z",
    fill: "#979797",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.979592 0C0.438578 0 0 0.438579 0 0.979592V6.85714C0 7.39816 0.438579 7.83673 0.979592 7.83673C1.52096 7.83673 1.95982 7.39787 1.95982 6.85651V2.93886C1.95982 2.39784 2.3984 1.95926 2.93941 1.95926H6.85706C7.39812 1.95926 7.83673 1.52065 7.83673 0.979592C7.83673 0.438578 7.39816 0 6.85714 0H0.979592Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3686 9.71345C15.3686 12.8378 12.8358 15.3706 9.7115 15.3706C6.58714 15.3706 4.05435 12.8378 4.05435 9.71345C4.05435 6.58909 6.58714 4.05631 9.7115 4.05631C12.8358 4.05631 15.3686 6.58909 15.3686 9.71345Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3686 9.71345C15.3686 12.8378 12.8358 15.3706 9.7115 15.3706C6.58714 15.3706 4.05435 12.8378 4.05435 9.71345C4.05435 6.58909 6.58714 4.05631 9.7115 4.05631C12.8358 4.05631 15.3686 6.58909 15.3686 9.71345Z",
    fill: "#D01400",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3686 9.71345C15.3686 12.8378 12.8358 15.3706 9.7115 15.3706C6.58714 15.3706 4.05435 12.8378 4.05435 9.71345C4.05435 6.58909 6.58714 4.05631 9.7115 4.05631C12.8358 4.05631 15.3686 6.58909 15.3686 9.71345Z",
    stroke: "white",
    strokeWidth: 1.25714
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.8123 9.29549H10.7395V6.79662C10.7395 6.21608 10.424 6.09618 10.0391 6.53159L9.76144 6.8471L7.41402 9.51635C7.0922 9.88234 7.22472 10.1789 7.71061 10.1789H8.78335V12.6778C8.78335 13.2583 9.09886 13.3782 9.48379 12.9428L9.76144 12.6273L12.1089 9.95807C12.4307 9.59207 12.2982 9.29549 11.8123 9.29549Z",
    fill: "#D01400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueUrgent);
export default __webpack_public_path__ + "static/media/queue_urgent.7749e911b5e5c59625842c95c466a228.svg";
export { ForwardRef as ReactComponent };